/* Sidebar Panels JavaScript/jQuery */
jQuery(function( $ ) {

    window.vmNotificationManager = new Vue({
        el: '#notifications',
        data: {
            notifications: [],
            id: 0,
        },
        methods: {
            addInfoNotification: function( message ) {
                this.notifications.push( { message: message, type: 'info', id: ++this.id } );
                return this.id;
            },
            addErrorNotification: function( message ) {
                if ( null == message ) {
                    message = "An error occured while trying to connect to the server.\
                    Please <a href='javascript:location.reload(true)'>refresh&nbsp;this&nbsp;page</a>";
                }
                this.notifications.push( { message: message, type: 'error', id: ++this.id } );
				let errorId = this.id;
				setTimeout( function() {
					vmNotificationManager.removeNotification( errorId );
				}, 5000 );
                return this.id;
            },
            removeNotification: function( id ) {
                this.notifications = this.notifications.filter( notificaton => notificaton.id != id );
            },
        }
    });

});
